import projects from "./projects/projects-loader";

projects();
